import { Button, Text } from "@chakra-ui/react";

import {
  ActiveRequestHelpPopover,
  HelpPopover,
} from "#app/components/index.jsx";

import { PricingCard } from "./PricingCard.jsx";
import { actionButtonProps } from "./shared.jsx";

export function UnlimitedPricingCard({
  name = "Legacy",
  colorScheme = "gray",
  ...props
} = {}) {
  const actionButton = (
    <Button isDisabled colorScheme={colorScheme} {...actionButtonProps}>
      Subscribe to Legacy
    </Button>
  );

  return (
    <PricingCard
      opacity={0.75}
      colorScheme={colorScheme}
      name={name}
      price={15}
      duration="/ mo"
      description="A legacy plan that you're grandfathered into."
      features={[
        "Unlimited notifications",
        <Text>Email, Text, and Push</Text>,
        <Text>
          7 <ActiveRequestHelpPopover />
        </Text>,
        "Checks every 1-5 minutes",
      ]}
      actionButton={actionButton}
      actionButtonHelperText={
        <>
          This plan is{" "}
          <HelpPopover
            size="sm"
            buttonText="no longer available"
            body="You may stay on this plan for as long as you like, but if you cancel/change it, you will not be able to re-subscribe to the same one."
          />{" "}
        </>
      }
      {...props}
    />
  );
}
